var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Information_2119897",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2353",
    "data-name": "Group 2353",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M127.814,136.805c-.275,1.06-3.063,1.139-2.867-.275.118-.943.314-1.846.471-2.788.079-.589-.314-.393-.628-.511-.236-.118-.236-.393.039-.432a16.708,16.708,0,0,1,2-.039c.236,0,.353.118.353.314a1.261,1.261,0,0,1-.039.55c-.157.9-.393,1.846-.471,2.71-.039.2,0,.55.275.55a2.977,2.977,0,0,0,.628-.236C127.736,136.57,127.814,136.687,127.814,136.805Z",
    transform: "translate(-119.723 -127.536)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M147.943,74a.93.93,0,0,1,.943.943.907.907,0,0,1-.943.943.943.943,0,0,1,0-1.885Z",
    transform: "translate(-141.227 -71.094)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M6.48,0A6.5,6.5,0,1,1,0,6.48,6.5,6.5,0,0,1,6.48,0Zm0,.982a5.5,5.5,0,1,0,5.5,5.5A5.515,5.515,0,0,0,6.48.982Z",
    transform: "translate(0 0)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.fb7c25da.svg";
export { ForwardRef as ReactComponent };